export default {
  background: true,
};
